import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DealComparisonEffects } from './deal-comparison.effects';
import { reducer } from './deal-comparison.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('dealComparison', reducer),
    EffectsModule.forFeature([DealComparisonEffects]),
  ],
  providers: [DealComparisonEffects],
})
export class DealComparisonStoreModule {}
